import { Label } from "reactstrap";
import styles from "./index.module.scss";

interface Option {
    value: string;
    label: string;
}

interface SelectFieldProps {
    label: string;
    id: string;
    value: string;
    options: Option[];
    onChange: (e: any) => void;
}

const SelectField = ({ label, id, value, options, onChange }: SelectFieldProps) => (
    <div className={styles.container}>
        <Label className={styles.label} htmlFor={id}>
            {label}
        </Label>
        <select className={styles.select} id={id} value={value} onChange={onChange}>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    </div>
);

export default SelectField;